<template>
    <td :class="[style['mds-data-table__cell'], addClass, rightAlignClass]" :style="headerConfig.style">
        <slot>
            <span :class="[style['mds-data-table__cell--item']]" v-html="content"></span>
        </slot>
    </td>
</template>

<script>
    export default {
        name: 'MdsDataTableCell',
        inject: ['bodyVariation'],
        props: {
            headerConfig: {
                type: Object,
            },
            cellData: {
                type: [String, Number, Boolean, Date],
            },
        },
        data() {
            return {
                align: null,
                style: this.bodyVariation.style,
            };
        },
        computed: {
            content() {
                return typeof this.headerConfig.transform !== 'function'
                    ? this.cellData
                    : this.headerConfig.transform(this.cellData);
            },
            addClass() {
                const obj = {};
                const newClass = this.style[this.headerConfig.class]
                    ? this.style[this.headerConfig.class]
                    : this.headerConfig.class;
                obj[newClass] = this.headerConfig.class;

                return obj;
            },
            rightAlignClass() {
                const obj = {};
                obj[this.style['mds-data-table__cell--right']] = this.headerConfig.align === 'right';

                return obj;
            },
        },
    };
</script>
